import { render } from "./VabeneIngredientTypeList.vue?vue&type=template&id=4f4ce5e6&ts=true"
import script from "./VabeneIngredientTypeList.vue?vue&type=script&lang=ts"
export * from "./VabeneIngredientTypeList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__